
export const AF_USER_SESSION_DATA = 'aff-user-session-data'
export const LANGUAGE = 'language';
export const COUNTRY_CODE = 'COUNTRY_CODE'
export const languageList = ['en','es','pt']